<div class="item-list-wrapper">
  @if (itemList?.length) {
    <ng-scrollbar class="d-none d-md-block" thumbClass="custom-scrollbars" appearance="standard" [reachedOffset]="40" (reachedBottom)="reachedBottom()">
      <div class="item-list">
        @for (item of itemList; track item) {
          <app-dashboard-item
            [item]="item"
            [paymentEnabled]="paymentEnabled">
          </app-dashboard-item>
        }
      </div>
    </ng-scrollbar>
    <div class="d-block d-md-none item-list overflow-hidden">
      <app-carousel
        type="dashboard-item"
        [items]="itemList"
        [config]="carouselConfig"
      (reachEnd)="reachedBottom()"></app-carousel>
    </div>
  }
  @if (isLoading) {
    <mat-spinner [diameter]="40"></mat-spinner>
  }
</div>
